<template>
	<widget title="File Tags" icon="fa-tag">

		<freemium-locked-alert v-if="$store.company.is_freemium == 1"></freemium-locked-alert>

		<table-list
			:records="mutatedTags"
			:fields="fields"
			record-name="File Tag"
			:hide-record-count="true"
			:has-delete="true"
			:has-edit="true"
			:sortable="true"
			delete-endpoint="FileTag/delete"
			v-on:modelChange="modelChange"
			v-on:edit="editTag">

			<button class="btn btn-success" v-on:click="newJobTag">
				<i class="fa fa-plus"></i>
				Add New Tag
			</button>

		</table-list>

		<modal-dialog
			:modal-visible="editModal.visible"
			title="Add/Edit Tag"
			confirm-button-text="Add"
			:working="editModal.working"
			v-on:confirm="addJobTag"
			v-on:closeModal="editModal.visible = false">

			<field 
				label="Tag Name"
				col-class="col-md-4"
				:params="{placeholder:'Tag Name'}" 
				v-model="editModal.tag"
				:readonly="editModal.is_system_tag == 1">
			</field>

			<field 
				label="Types"
				col-class="col-md-4"
				:params="{type:'checklist',options:typeOptions}"
				v-model="editModal.jobTypes">
			</field>

			<template v-if="isForProjectOrService">
				<field 
					label="Read Permissions"
					col-class="col-md-4"
					:params="{type:'select-multi',options:roleOptions}" 
					v-model="editModal.permissions.read">
					<div class="text-muted">Leave blank to keep permissions open</div>
				</field>

				<field 
					label="Write Permissions"
					col-class="col-md-4"
					:params="{type:'select-multi',options:roleOptions}" 
					v-on:change="writePermsChanged"
					v-model="editModal.permissions.write">
					<div class="text-muted">Leave blank to keep permissions open</div>
				</field>
			</template>

		</modal-dialog>
	</widget>
</template>
<script type="text/javascript">
import Widget from "@/components/Widget"
import TableList from "@/components/TableList"
import Field from "@/components/Field"
import ModalDialog from "@/components/ModalDialog"
import FreemiumLockedAlert from "@/components/FreemiumLockedAlert"

export default {
	name: "FileTagManagerWidget",
	components: {
		Widget,
		TableList,
		Field,
		ModalDialog,
		FreemiumLockedAlert
	},
	props:["tags"],
	data(){
		return {
			catName: "",
			editModal: {
				visible: false,
				tag: "",
				jobTypes: [],
				permissions: {
					read: [],
					write:[]
				},
				is_system_tag: 0,
				working: false
			},
			localTags: [],
			personnelRoles: [],
			fields: [
				{label: "Tag Name",key:"name"},
				{label: "File Store",key:'jobType'},
				{label: "Read Permissions",key: "readPerms"},
				{label: "Write Permissions",key: "writePerms"}
			],
			typeMap: {
				is_for_library: "Library",
				is_for_services: "Services",
				is_for_projects: "Projects",
				is_for_service_contracts: "Service Contracts",
				is_for_contacts: "Contacts",
				is_for_equipment: "Equipment",
				is_for_customer_assets: "Customer Assets"
			}
		} 
	},
	watch: {
		tags() {
			if (this.tags) 
				this.localTags = this.tags
		}
	},
	computed: {
		isForProjectOrService() {
			if (this.editModal.jobTypes.indexOf("Projects") >= 0 || this.editModal.jobTypes.indexOf("Services") >= 0)
				return true

			return false
		},
		typeOptions() {
			let vm = this
			return Object.keys(this.typeMap).map(key => {
				return {
					text: vm.typeMap[key],
					value: vm.typeMap[key] 
				}
			})
		},
		roleOptions() {
			return this.optionify(this.personnelRoles,"title")
		},
		mutatedTags() {
			let vm = this

			if (!this.localTags)
				return []

			return this.localTags.map(tag => {
				
				let readPerms = []
				try {
					readPerms = JSON.parse(tag.read_permissions_json)
				}
				catch (ex) {}

				tag.readPerms = readPerms.map(perm => {
					return vm.roleOptions.find(role => role.value == perm) ? vm.roleOptions.find(role => role.value == perm).text : ""
				}).join(", ")

				let writePerms = []
				try {
					writePerms = JSON.parse(tag.write_permissions_json)
				}
				catch (ex) {}

				tag.writePerms = writePerms.map(perm => {
					return vm.roleOptions.find(role => role.value == perm) ? vm.roleOptions.find(role => role.value == perm).text : ""
				}).join(", ")

				let typeArray = []

				Object.keys(vm.typeMap).forEach(key => {
					if (tag[key] == 1)
						typeArray.push(vm.typeMap[key])
				})

				tag.jobType = typeArray.join(", ")

				return tag
			})
		}
	},
	methods: {
		modelChange() {
			this.$emit('modelChange')
			this.fetchTags()
		},
		writePermsChanged() {
			let vm = this

			//automatically add write perms to read perms
			this.$nextTick(() => {
				vm.editModal.permissions.write.forEach(writePerm => {
					if (!vm.editModal.permissions.read.find(readPerm => writePerm == readPerm))
						vm.editModal.permissions.read.push(writePerm)
				})
			})
		},
		newJobTag() {
			this.editModal = {
				visible: true,
				tag: "",
				permissions: {
					read: [],
					write: []
				},
				working: false,
				jobTypes: ["Library","Projects","Services"]
			}
		},
		addJobTag() {
			let vm = this

			let payload = {
				name: this.editModal.tag,
				read_permissions_json: JSON.stringify(this.editModal.permissions.read),
				write_permissions_json: JSON.stringify(this.editModal.permissions.write)
			}

			Object.keys(this.typeMap).forEach(key => {
				if (vm.editModal.jobTypes.indexOf(vm.typeMap[key]) >= 0)
					payload[key] = 1
				else
					payload[key] = 0
			})	

			if ("id" in this.editModal && this.editModal.id)
				payload.id = this.editModal.id

			this.editModal.working = true

			this.postData("FileTag/save",payload,true).then(response => {
				vm.editModal.working = false

				if (response.success) {
					vm.editModal.visible = false
					vm.fetchTags()
					vm.$emit("modelChange")
				}
			})
		},
		editTag(tag) {
			let vm = this

			let jobTypes = []
			Object.keys(this.typeMap).forEach(key => {
				if (tag[key] == 1)
					jobTypes.push(vm.typeMap[key])
			})

			this.editModal = {
				visible: true,
				id: tag.id,
				tag: tag.name,
				permissions: {
					read: [],
					write: []
				},
				jobTypes,
				is_system_tag: tag.is_system_tag,
				working: false
			}

			try {
				this.editModal.permissions.read = JSON.parse(tag.read_permissions_json)
			}
			catch (e) {}

			try {
				this.editModal.permissions.write = JSON.parse(tag.write_permissions_json)
			}
			catch (e) {}

		},
		fetchJobPersonnelRoles() {
			let vm = this

			this.getJSON("JobPersonnelRole/get",{fields: ['id',"slug","title"]},true).then(response => {
				if (response.success)
					vm.personnelRoles = response.data
			})
		},
		fetchTags() {
			let vm = this

			this.getJSON("FileTag/get").then(response => {
				vm.localTags = response.data
			})
		}
	},
	created() {
		this.fetchJobPersonnelRoles()

		if (this.tags)
			this.localTags = this.tags 
		else
			this.fetchTags()
	}
}
</script>